(() => {
    if (window.declockFilterTriggerInitialized) return;
    window.declockFilterTriggerInitialized = true;

    const getMobileFacets = (trigger) => {
      const container = trigger.closest('.facets-container, .facets-container-drawer') || document;
      const drawer =
        container.querySelector('menu-drawer.mobile-facets__wrapper') ||
        document.querySelector('menu-drawer.mobile-facets__wrapper');

      if (!drawer) return {};

      const disclosure =
        drawer.querySelector('details.mobile-facets__disclosure') ||
        drawer.querySelector('details');
      const summary = disclosure && disclosure.querySelector('summary.mobile-facets__open-wrapper, summary');

      return { drawer, disclosure, summary };
    };

    const setMobileFacetsState = (trigger, shouldOpen) => {
      const { drawer, disclosure, summary } = getMobileFacets(trigger);
      if (!drawer || !disclosure || !summary) return;

      const breakpointClass = `overflow-hidden-${drawer.dataset.breakpoint || 'mobile'}`;

      if (shouldOpen) {
        disclosure.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        trigger.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(() => disclosure.classList.add('menu-opening'));
      } else {
        disclosure.classList.remove('menu-opening');
        summary.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-expanded', 'false');
        window.setTimeout(() => disclosure.removeAttribute('open'), 180);
      }

      document.body.classList.remove(breakpointClass);
    };

    document.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-declock-filter-close]');
      const trigger = event.target.closest('[data-declock-filter-trigger]');
      if (!trigger && !closeButton) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (closeButton) {
        const container = closeButton.closest('.facets-container, .facets-container-drawer') || document;
        const toolbarTrigger = container.querySelector('[data-declock-filter-trigger]');
        if (toolbarTrigger) setMobileFacetsState(toolbarTrigger, false);
        return;
      }

      const { disclosure } = getMobileFacets(trigger);
      const isOpen = Boolean(disclosure && disclosure.classList.contains('menu-opening'));
      setMobileFacetsState(trigger, !isOpen);
    }, true);
  })();
